export enum NotifKey {
	DirectCall = 'DirectCall',
	Workflow = 'Workflow',
	DirectSMS = 'DirectSMS',
	CRM = 'CRM',
	Voicemail = 'Voicemail',
	Calendar = 'Calendar',
	Robocall = 'Robocall',
	Intake = 'Intake',
}
